module.exports = __webpack_public_path__ + "static/media/bliss.216d20df.bmp";